var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaveDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.2285 5.23333V22C24.2285 22.5333 24.0285 23 23.6285 23.4C23.2285 23.8 22.7619 24 22.2285 24H2.22852C1.69518 24 1.22852 23.8 0.828516 23.4C0.428516 23 0.228516 22.5333 0.228516 22V2C0.228516 1.46667 0.428516 1 0.828516 0.6C1.22852 0.2 1.69518 0 2.22852 0H18.9952L24.2285 5.23333ZM22.2285 6.13333L18.0952 2H2.22852V22H22.2285V6.13333ZM12.2285 19.8333C13.1841 19.8333 14.0007 19.4944 14.6785 18.8167C15.3563 18.1389 15.6952 17.3222 15.6952 16.3667C15.6952 15.4111 15.3563 14.5944 14.6785 13.9167C14.0007 13.2389 13.1841 12.9 12.2285 12.9C11.273 12.9 10.4563 13.2389 9.77852 13.9167C9.10074 14.5944 8.76185 15.4111 8.76185 16.3667C8.76185 17.3222 9.10074 18.1389 9.77852 18.8167C10.4563 19.4944 11.273 19.8333 12.2285 19.8333ZM3.99518 8.53333H15.9285V3.76667H3.99518V8.53333ZM2.22852 6.13333V22V2V6.13333Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveDisabled);
export default __webpack_public_path__ + "static/media/save_disabled.88c8ba8c46d43014b905db50700788ba.svg";
export { ForwardRef as ReactComponent };